export default "__VITE_ASSET__oy92UMNC__"